import _ from 'lodash';

import * as ImportApi from '../../api/app-migration';
import { APP_MIGRATION_IMPORT_APIS, STATUSES } from '../constants/import.constants';

export const getImportApiCall = (apiStep) => {
  switch (apiStep) {
    case APP_MIGRATION_IMPORT_APIS.UPLOAD:
      return ImportApi.uploadAppMigrationImport;

    case APP_MIGRATION_IMPORT_APIS.IMPORT:
      return ImportApi.appMigrationImport;

    case APP_MIGRATION_IMPORT_APIS.CHECK_STATUS:
      return ImportApi.appMigrationImportStatus;

    case APP_MIGRATION_IMPORT_APIS.DOWNLOAD_RESULT:
      return ImportApi.appMigrationDownloadFile;

    case APP_MIGRATION_IMPORT_APIS.CANCEL:
      return ImportApi.appMigrationCancel;

    case APP_MIGRATION_IMPORT_APIS.INSERT_ACTIVITY_LOG:
      return ImportApi.appMigrationInsertActivityLog;

    default:
      return;
  }
};

export const getErrorMessage = (apiErrors, defaultMessage) => {
  if (Array.isArray(apiErrors)) {
    return apiErrors[0].errorMessage || defaultMessage;
  } else if (typeof apiErrors === 'object' && apiErrors !== null) {
    return apiErrors.errorMessage || defaultMessage;
  } else {
    return apiErrors || defaultMessage;
  }
};

export const getImportCountByStatusCode = (importStatuses, statusCode) => {
  return importStatuses?.filter((record) => record?.StatusCode === statusCode).length;
};

export const getRecordTitle = (errorCount) => {
  return errorCount === 1 ? 'record' : 'records';
};

export const parseNotificationUrl = (link) => {
  if (link) {
    const [pathname, search] = link.split('?');
    return { pathname, search };
  }

  return {};
};

export const preprocessImportStatusesRequest = (importStatuses) =>
  importStatuses
    .filter((status) => status.Checked)
    .map(({ id, Checked, ...importStatus }) => {
      return importStatus;
    });

export const updateImportStatusesWithResponse = (importStatuses, currentImportStatuses) => {
  return currentImportStatuses.map((importStatus) => {
    const statusFromResponse = importStatuses.find(
      (s) =>
        (s.Name ?? '').toString().toLowerCase() ===
        (importStatus.Name ?? '').toString().toLowerCase()
    );
    return statusFromResponse
      ? {
          ...importStatus,
          StatusCode: statusFromResponse.StatusCode,
          Messages: statusFromResponse.Messages,
          ComparisonMessage: statusFromResponse.ComparisonMessage,
          ComparisonDesignerLink: statusFromResponse.ComparisonDesignerLink,
          ComparisonDeltaLink: statusFromResponse.ComparisonDeltaLink,
        }
      : { ...importStatus };
  });
};

export const updateImportStatusesWithCancelResponse = (importStatuses, currentImportStatuses) => {
  return currentImportStatuses.map((importStatus) => {
    const statusFromResponse = importStatuses.find(
      (s) =>
        (s.Name ?? '').toString().toLowerCase() ===
        (importStatus.Name ?? '').toString().toLowerCase()
    );
    return statusFromResponse
      ? {
          ...importStatus,
          StatusCode: statusFromResponse.StatusCode,
          Messages: statusFromResponse.Messages,
          ComparisonMessage: statusFromResponse.ComparisonMessage,
          ComparisonDesignerLink: statusFromResponse.ComparisonDesignerLink,
          ComparisonDeltaLink: statusFromResponse.ComparisonDeltaLink,
        }
      : {
          ...importStatus,
          StatusCode: [STATUSES.COMPLETED, STATUSES.ERROR].includes(importStatus.StatusCode)
            ? importStatus.StatusCode
            : STATUSES.CANCEL,
        };
  });
};

export const preprocessImportStatusesResponse = (importStatuses) =>
  importStatuses.map((importStatus, index) => {
    return { ...importStatus, id: `${index}`, Checked: true, StatusCode: STATUSES.IN_PROGRESS };
  });

export const preprocessImportStatusesResponseFromNotification = (importStatuses) =>
  importStatuses.map((importStatus, index) => {
    return { ...importStatus, id: `${index}`, Checked: true };
  });

export const getOverallImportStatus = (importStatuses) => {
  return importStatuses.filter((s) => s.StatusCode === STATUSES.CANCEL).length
    ? STATUSES.CANCEL
    : importStatuses.filter((s) => s.StatusCode === STATUSES.IN_PROGRESS).length
    ? STATUSES.IN_PROGRESS
    : STATUSES.COMPLETED;
};

export const equalityFn = (prev, next) => _.isEqual(prev, next);
